
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Tip, ModerationEnum } from "@/types";

@Component
export default class DisplayTips extends Vue {
  @Prop() tips!: Tip[];

  @Prop() loading!: boolean;

  isLoading: boolean = false;

  moderationEnum = ModerationEnum;

  selected: any = [];

  pagination: any = {
    sortBy: "createdAt"
  };

  headers: any = [
    { text: "Titre", value: "title" },
    { text: "Date de création", value: "createdAt" },
    { text: "Moderation", value: "moderation" },
    { text: "Actions", value: "action", sortable: false }
  ];

  search: String = "";

  @Watch("loading", { immediate: true })
  handleLoadingChange(value: boolean) {
    this.isLoading = value;
  }

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.tips.slice();
  }

  changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
